import { render } from "./login-phone-otp.vue?vue&type=template&id=6b23dd78"
import script from "./login-phone-otp.vue?vue&type=script&lang=js"
export * from "./login-phone-otp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__